import {inject, Injectable} from '@angular/core';
import {SearchParameters, SearchParametersForOverview} from "./definitions/search-parameters";
import {CmsApiService} from "./cms-api.service";
import {SearchResult} from "./definitions/search-result";
import {CmsQueueService} from "./cms-queue.service";

@Injectable({
  providedIn: 'root'
})
export class SearchService {
  // Injections
  private readonly cms: CmsApiService = inject(CmsApiService);
  private readonly cmsQueue: CmsQueueService = inject(CmsQueueService);

  async search(searchParams: SearchParameters) {
    searchParams['q.op'] = searchParams['q.op'] || 'AND';
    return this.cms.search(searchParams);
  }

  async searchWithOverview(params: SearchParametersForOverview): Promise<SearchResult> {
    return new Promise((resolve, reject) => {

      params['q.op'] = params['q.op'] || 'AND';
      // Forcing all calls towards searchWithOverview to be queued in order to avoid async issues
      this.cmsQueue.runCmsFnWithQueue(
        this.cms.searchWithOverview,
        params,
        true,
        (res: any) => {
          resolve(res);
        },
        (e: any) => {
          reject(new Error(e));
        },
        true
      )

    });
  }



}
